<template>
  <v-card @click="changeDialog" class="item" flat height="100%">
    <img v-if="item.img" :src="files + item.img" class="d-block item-img" />

    <div class="pa-3 pa-md-5 item-caption">
      <div
        v-if="item.office"
        class="secondary--text text--lighten-2 text-caption font-weight-regular"
      >
        {{ item.office }}
      </div>
      <div
        v-if="item.title"
        class="secondary--text text-h6 text-md-h5 font-weight-bold mt-2"
      >
        {{ item.title }}
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title
          class="
            align-end
            secondary--text
            text-h5 text-md-h4
            font-weight-bold
            pr-12
          "
        >
          {{ item.title }}
          <span
            v-if="item.office"
            class="text-h6 text-md-h5 font-weight-bold ml-2"
          >
            - {{ item.office }}
          </span>

          <v-btn
            @click="changeDialog"
            class="white--text pa-0 ml-auto dialog-item-close"
            color="secondary"
            min-width="auto"
            height="30px"
            width="30px"
            depressed
            rounded
          >
            <v-icon size="18"> fa-times </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="5" md="4" class="mt-4">
              <img
                v-if="item.img"
                :src="files + item.img"
                :alt="item.title"
                class="d-block dialog-item-img"
              />
            </v-col>
            <v-col cols="12" sm="7" md="8" class="mt-4">
              <div
                v-if="item.text"
                class="text-body-2 font-weight-regular"
                v-html="item.text"
              ></div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    changeDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 9 / 11;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
}
.dialog-item-img {
  aspect-ratio: 9 / 11;
  border: 1px solid #dddddd;
  object-fit: cover;
  -o-object-fit: cover;
  width: 100%;
}
.dialog-item-close {
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>
